// src/components/charts/AuditsByClientChart.tsx
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Audit, Client } from '../../types';

type ApexOptions = any;

interface AuditsByClientChartProps {
  audits: Audit[];
  clients: Client[];
}

const AuditsByClientChart: React.FC<AuditsByClientChartProps> = ({ audits, clients }) => {
  // Agrupar auditorías por cliente
  const auditsByClient = audits.reduce((acc, audit) => {
    acc[audit.clientId] = (acc[audit.clientId] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const labels = Object.keys(auditsByClient).map(clientId => {
    const client = clients.find(c => c.id === clientId);
    return client?.companyName || 'Desconocido';
  });

  const data = Object.values(auditsByClient);

  const options: ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels: labels,
    colors: ['#1890ff', '#52c41a', '#faad14', '#f5222d'],
    legend: {
      position: 'bottom',
    },
    title: {
      text: 'Auditorías por Cliente',
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 600,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total',
              fontSize: '16px',
              fontWeight: 600,
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val} auditoría${val !== 1 ? 's' : ''}`,
      },
    },
  };

  return <ReactApexChart options={options} series={data} type="donut" height={300} />;
};

export default AuditsByClientChart;
